import React, { Component } from "react";
import { SERVER_TIMEOUT } from "../constants";
import PolicyCards from "./PolicyCards";
import { PolicyType, SendWSCommand, WSCommandType } from "../types";
import "./Prompts.css";

type PeekPromptProps = {
  policies: PolicyType[];
  sendWSCommand: SendWSCommand;
};

type PeekPromptState = {
  waitingForServer: boolean;
};

const PEEK_TAGS = ["Top card", "2nd", "3rd"];

class PeekPrompt extends Component<PeekPromptProps, PeekPromptState> {
  timeoutID: NodeJS.Timeout | undefined;

  constructor(props: PeekPromptProps) {
    super(props);
    this.state = {
      waitingForServer: false,
    };
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onButtonClick() {
    // Lock the button so that it can't be pressed multiple times.
    this.setState({ waitingForServer: true });
    this.timeoutID = setTimeout(() => {
      this.setState({ waitingForServer: false });
    }, SERVER_TIMEOUT);

    // Contact the server using provided method.
    this.props.sendWSCommand({ command: WSCommandType.REGISTER_PEEK });
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutID);
  }

  render() {
    return (
      <div className="pp">
        <div className="pp-kicker">Presidential power · policy peek</div>
        <div className="pp-title">The next three policies</div>
        <div className="pp-text">
          This is the top of the draw pile, in the order it will be drawn. Only you can see it, and what you tell the
          table is up to you.
        </div>
        <PolicyCards policies={this.props.policies} tags={PEEK_TAGS} />
        <div className="pp-actions">
          <button
            id="prompt-button"
            className="gold-button pp-btn"
            onClick={this.onButtonClick}
            disabled={this.state.waitingForServer}
          >
            <span className="gold-label">OKAY</span>
          </button>
        </div>
      </div>
    );
  }
}

export default PeekPrompt;
